<!--列表查看视图-->
<template>
  <div>
    <template v-if="lob==='AI'">
      <ai-master-basic-tab v-if="masterFlag" ref="tabAIBasicMaster" :context="seContext" :action="action" view-source="financeDetail" />
      <ai-basic-tab v-if="!masterFlag" ref="tabAIBasic" :context="seContext" :action="action" />
    </template>
    <template v-if="lob==='AE'">
      <ae-master-basic-tab v-if="masterFlag" ref="tabAEBasicMaster" :context="seContext" :action="action" view-source="financeDetail" />
      <ae-basic-tab v-if="!masterFlag" ref="tabAEBasic" :context="seContext" :action="action" />
    </template>

    <template v-if="lob==='SI'">
      <si-master-basic-tab v-if="masterFlag" ref="tabSiBasicMaster" :context="seContext" :action="action" view-source="financeDetail" />
      <si-basic-tab v-if="!masterFlag" ref="tabSiBasic" :context="seContext" :action="action" />
    </template>
    <template v-if="lob==='SE'">
      <tab-booking-master v-if="masterFlag" ref="tabBookingMaster" :context="seContext" :action="action" class="se-basic-tab" view-source="financeDetail" />
      <tab-booking-fcl v-if="!masterFlag" ref="tabBookingFCL" :context="seContext" :action="action" class="se-basic-tab" />
    </template>
    <template v-if="lob==='RE' || lob==='RI'">
      <re-tab-booking-master v-if="masterFlag" ref="reTabBookingMaster" :context="seContext" :action="action" view-source="financeDetail" />
      <re-tab-booking-fcl v-if="!masterFlag" ref="reTabBookingFcl" :context="seContext" :action="action" />
    </template>
  </div>
</template>

<script>

import { getLoading } from '@/utils/utilBaseElement'

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import aiBasicTab from '@/views/cargo/v0/AirImport/components/booking/tabs/tabBookingFCL.vue'
import aiMasterBasicTab from '@/views/cargo/v0/AirImport/components/booking/tabs/tabBookingMaster.vue'

import aeBasicTab from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabGeneral'
import aeMasterBasicTab from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabMaster'

import siBasicTab from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/basicTab'
import siMasterBasicTab from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/masterBasicTab'
import reTabBookingFcl from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingFCL'
import reTabBookingMaster from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingMaster'

import seBasicTab from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingFCL'
import seMasterBasicTab from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingMaster'
import tabBookingFcl from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingFCL'
import tabBookingMaster from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingMaster'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'FinanceDetail',
  components: { tabBookingMaster, tabBookingFcl, cargoAdvanceSelect, seBasicTab, seMasterBasicTab, reTabBookingFcl, reTabBookingMaster, siMasterBasicTab, aeMasterBasicTab, aiMasterBasicTab, aiBasicTab, aeBasicTab, siBasicTab },
  props: {
    job: { type: Object, required: true },
    lob: { type: String, required: true, validator: (value) => { return ['AE', 'SE', 'SI', 'RE', 'AI', ''].includes(value) } }, // AE SE SI RWE, ''(空字符串）为解决初始化警告问题
    masterFlag: { type: Boolean, required: true },
    seContext: { type: Object, required: false }
  },
  data() {
    return {
      loading: false,
      selectTypeNames: TYPE_NAMES,
      activeTabName: 'aiBasicTab',
      action: 'look'
    }
  },
  methods: {
    onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      this.loading = getLoading()
      switch (this.lob) {
        case 'SE': {
          this.$nextTick(() => {
            const activeTabName = this.masterFlag ? 'tabBookingMaster' : 'tabBookingFCL'
            this.$refs[activeTabName].onShow(this.job, true)
          })
          break
        }
        case 'SI': {
          this.$nextTick(() => {
            const activeTabName = this.masterFlag ? 'tabSiBasicMaster' : 'tabSiBasic'
            this.$refs[activeTabName].onShow(this.job, true)
          })
          break
        }
        case 'AE': {
          this.$nextTick(() => {
            const activeTabName = this.masterFlag ? 'tabAEBasicMaster' : 'tabAEBasic'
            this.$refs[activeTabName].onShow(this.job, true)
          })
          break
        }
        case 'AI': {
          this.$nextTick(() => {
            const activeTabName = this.masterFlag ? 'tabAIBasicMaster' : 'tabAIBasic'
            this.$refs[activeTabName].onShow(this.job, true)
          })
          break
        }
        case 'RE': {
          const activeTabName = this.masterFlag ? 'reTabBookingMaster' : 'reTabBookingFcl'
          this.$refs[activeTabName].onShow(this.job, isRefresh)
          break
        }
      }
      this.loading.close()
    }
  }
}
</script>

<style lang="scss">

</style>
